<template>
  <section class="section is-paddingless">
    <div class="container is-fluid is-paddingless">

      <nav class="navbar is-spacedre  " role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <router-link class="navbar-item" :to="{ name: 'home' }">
              <img alt="Car Trackr Logo" src="../assets/logo.svg" width="28" height="28">
              Car Trackr
            </router-link>

            <a role="button" class="navbar-burger burger" aria-label="menu"
               aria-expanded="false" data-target="navbarBasicExample">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div class="navbar-menu">
            <div class="navbar-end">
              <router-link
                :to="{ name: 'getting-started' }"
                class="navbar-item"
                active-class="is-active"
              >
                Getting Started
              </router-link>
              <router-link
                :to="{ name: 'about-us' }"
                class="navbar-item"
                active-class="is-active"
              >
                About Us
              </router-link>
            </div>
          </div>
        </div>
      </nav>

    </div>
    <slot />

    <site-footer />
  </section>
</template>

<script>
import SiteFooter from '../components/global/SiteFooter.vue';

export default {
  name: 'Default',
  components: { SiteFooter },
};
</script>

<style lang="scss" scoped>
  .navbar {
    .navbar-item {
      img {
        margin-right: .75rem;
      }
    }
  }
</style>
